/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ClusterStates } from '../../server';
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetProject } from './project.get';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetProjectsWithClusters = {
  id: 'projects-with-clusters.get',
  tag: 'Project',
  summary: 'Get projects with clusters',
  description: 'Retrieve all projects, including their clusters, within an organization',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/project/cluster`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            GetProject.response['200'].content['application/json'].schema.merge(
              z.strictObject({
                clusters: z.array(
                  z.strictObject({
                    id: ZodTypes.Id,
                    name: ZodTypes.KubernetesIdentifier,
                    description: z.string().min(1).nullable().optional(),
                    creatorId: ZodTypes.Id.nullable(),
                    status: z.nativeEnum(ClusterStates).optional(),
                    namespace: z.string().min(1).optional(),
                    type: ZodTypes.ServiceType,
                  }),
                ),
              }),
            ),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
